import script from "./EditExtensionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditExtensionDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditExtensionDialog.vue?vue&type=style&index=0&id=46fb0cf9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46fb0cf9"]])

export default __exports__